import React from 'react';

export default function Logo() {

  return (
    <img src={require(`../images/florence-white-blue.png`)} alt="Logo Florence"/> 
  )
}
  
